import React from "react";
import { Tab } from "@headlessui/react";
import { classNameFilter } from "../../utils/ComponentHelpers";
const TabsComponent = ({
  categories,
  onChange,
  selectedIndex
}) => {
  return /*#__PURE__*/React.createElement(Tab.Group, {
    onChange: onChange,
    selectedIndex: selectedIndex
  }, /*#__PURE__*/React.createElement(Tab.List, {
    className: "inline-flex space-x-2 rounded-xl bg-gray-100 p-1.5"
  }, categories.map(type => /*#__PURE__*/React.createElement(Tab, {
    key: type,
    className: ({
      selected
    }) => classNameFilter("py-2.5 px-3.5 font-semibold rounded-md", selected ? "bg-white hover:bg-white shadow-sm text-gray-900" : "text-gray-500 hover:bg-gray-200")
  }, type))));
};
export { TabsComponent };